module.exports = __webpack_public_path__ + "img/principal-img.cde17523.png";